import React from 'react';
import { Users, Mic, Package, Truck, HardHat, Shield, Camera, Paperclip, Cloud, CheckCircle, AlertCircle } from 'lucide-react';
interface DailyReportProps {
  siteId: string | null;
}
interface ReportSection {
  id: string;
  title: string;
  icon: React.ReactNode;
  status: 'complete' | 'incomplete' | 'empty';
}
export function DailyReport({
  siteId
}: DailyReportProps) {
  if (!siteId) {
    return <div className="flex flex-col items-center justify-center h-full p-8 text-center" data-id="element-41">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-42">
          <HardHat size={32} className="text-gray-400" data-id="element-43" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-44">
          Sélectionnez un chantier
        </h2>
        <p className="text-gray-600" data-id="element-45">
          Choisissez un chantier dans l'onglet Chantiers pour commencer votre
          rapport.
        </p>
      </div>;
  }
  const sections: ReportSection[] = [{
    id: 'team',
    title: 'Équipe & Heures',
    icon: <Users size={24} data-id="element-46" />,
    status: 'complete'
  }, {
    id: 'work',
    title: 'Travaux (Dictée)',
    icon: <Mic size={24} data-id="element-47" />,
    status: 'incomplete'
  }, {
    id: 'materials',
    title: 'Matériaux',
    icon: <Package size={24} data-id="element-48" />,
    status: 'empty'
  }, {
    id: 'machinery',
    title: 'Machinerie',
    icon: <Truck size={24} data-id="element-49" />,
    status: 'complete'
  }, {
    id: 'subcontractors',
    title: 'Sous-traitants',
    icon: <HardHat size={24} data-id="element-50" />,
    status: 'empty'
  }, {
    id: 'safety',
    title: 'Sécurité & Qualité',
    icon: <Shield size={24} data-id="element-51" />,
    status: 'incomplete'
  }, {
    id: 'media',
    title: 'Médias',
    icon: <Camera size={24} data-id="element-52" />,
    status: 'complete'
  }, {
    id: 'attachments',
    title: 'Pièces jointes',
    icon: <Paperclip size={24} data-id="element-53" />,
    status: 'empty'
  }, {
    id: 'weather',
    title: 'Météo',
    icon: <Cloud size={24} data-id="element-54" />,
    status: 'complete'
  }];
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'complete':
        return <CheckCircle size={20} className="text-green-600" data-id="element-55" />;
      case 'incomplete':
        return <AlertCircle size={20} className="text-orange-600" data-id="element-56" />;
      default:
        return <div className="w-5 h-5 border-2 border-gray-300 rounded-full" data-id="element-57" />;
    }
  };
  return <div className="p-4 space-y-4" data-id="element-58">
      {/* Header Card */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-59">
        <h2 className="font-semibold text-blue-900 mb-1" data-id="element-60">Rapport du jour</h2>
        <p className="text-sm text-blue-700" data-id="element-61">{siteId}</p>
        <p className="text-xs text-blue-600 mt-2" data-id="element-62">
          Dernière sauvegarde: Il y a 2 minutes
        </p>
      </div>
      {/* Report Sections */}
      <div className="space-y-3" data-id="element-63">
        {sections.map(section => <button key={section.id} className="w-full bg-white rounded-lg border border-gray-200 p-4 flex items-center justify-between hover:shadow-md transition-shadow" data-id="element-64">
            <div className="flex items-center space-x-3" data-id="element-65">
              <div className="text-blue-600" data-id="element-66">{section.icon}</div>
              <span className="font-medium text-gray-900" data-id="element-67">{section.title}</span>
            </div>
            {getStatusBadge(section.status)}
          </button>)}
      </div>
      {/* Action Buttons */}
      <div className="fixed bottom-20 left-0 right-0 p-4 bg-gradient-to-t from-gray-50 to-transparent" data-id="element-68">
        <div className="space-y-2" data-id="element-69">
          <button className="w-full bg-white border-2 border-blue-600 text-blue-600 font-semibold py-3 rounded-lg hover:bg-blue-50 transition-colors" data-id="element-70">
            Sauver brouillon
          </button>
          <button className="w-full bg-blue-600 text-white font-semibold py-3 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-71">
            Soumettre le rapport
          </button>
        </div>
      </div>
    </div>;
}